import { pagingToParams } from 'modules/utils';
import { axiosInstance } from './axios';
import { PagingParams } from '../types/PagingParams';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getInboxMessages = async (params: PagingParams) => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/inbox`,
    { params: pagingToParams(params) },
  );

  // Spring Page object contains content in the content field
  const {
    data: { content, totalPages },
  } = response;

  return {
    messages: content,
    totalPageCount: totalPages,
    page: params.page,
  };
};

export const getUnreadesageCount = async () => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/inbox/count-unread`,
  );

  const unreadMessageCount = response.data;

  return unreadMessageCount;
};

export const markMessageAsRead = async (id: number) => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/inbox/read/${id}`,
  );

  return response.status === 200;
};
